import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
const sleep = (ms) => new Promise((res) => setTimeout(res, ms));
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    // Transient network failure (server briefly unreachable, e.g. during a deploy/reload):
    // the request never reached the server, so retrying is safe. Retry up to 2x with a short delay.
    const isNetwork = !err.response && err.code !== "ERR_CANCELED";
    if (isNetwork && (cfg._netRetry || 0) < 2) {
      cfg._netRetry = (cfg._netRetry || 0) + 1;
      await sleep(1200);
      return api(cfg);
    }
    if (err.response?.status === 401 && !cfg._retry && !String(cfg.url).includes("/auth/")) {
      cfg._retry = true;
      refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
      try {
        await refreshing;
        return api(cfg);
      } catch (e) {
        return Promise.reject(err);
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  if (!e?.response && (e?.code === "ERR_NETWORK" || e?.message === "Network Error")) {
    return "Verbindung zum Server unterbrochen. Bitte in ein paar Sekunden erneut versuchen.";
  }
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Etwas ist schiefgelaufen.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  if (typeof d.message === "string") return d.message;
  return String(d);
}

export const eur = (n) => new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(Number(n) || 0);
export const fmtDate = (iso, lang = "de") =>
  iso ? new Date(iso).toLocaleDateString(lang === "en" ? "en-GB" : "de-DE", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" }) : "–";
export const fmtDateTime = (iso, lang = "de") =>
  iso ? new Date(iso).toLocaleString(lang === "en" ? "en-GB" : "de-DE", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }) : "–";

export async function fetchBlobUrl(fileId) {
  const r = await api.get(`/files/${fileId}`, { responseType: "blob" });
  return URL.createObjectURL(r.data);
}
